import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const patientIdParam = (value: unknown): number | null => {
  const n = Number(value);
  if (!Number.isInteger(n) || n <= 0) return null;
  return n;
};
